import React from "react";
var Edelicon = function (props) {
    var _a;
    return (React.createElement("i", { className: props === null || props === void 0 ? void 0 : props.className, onClick: function (e) {
            (props === null || props === void 0 ? void 0 : props.onClick) && (props === null || props === void 0 ? void 0 : props.onClick(e));
        } }, Array.from({ length: (_a = props === null || props === void 0 ? void 0 : props.paths) !== null && _a !== void 0 ? _a : 0 }, function (_, index) { return (React.createElement("span", { key: index, className: "path".concat(index + 1) })); })));
};
export default Edelicon;
